import { PlanService } from "core/service";
import { PlanPersistence } from "core/persistence";
import BaseRepository from "core/repository/base.repository";

class PlanRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "plan";
  }

  resourceName() {
    return "planos";
  }

  getServiceProvider() {
    return PlanService;
  }

  getPersistenceProvider() {
    return PlanPersistence;
  }

  async subscribePlan(params) {
    return this.mService.subscribePlan(params);
  }

  async changePlan(params) {
    return this.mService.changePlan(params);
  }

  async changePaymentMethod(params) {
    return this.mService.changePaymentMethod(params);
  }
}

export default new PlanRepository();



// WEBPACK FOOTER //
// ./src/core/repository/plan.repository.js